/**
 * DynamicPageRenderer — iterates section JSON, looks up each type in SectionRegistry,
 * and renders it inside a SectionWrapper that applies layout/responsive config.
 * Unknown section types are skipped gracefully.
 *
 * `embeddedFooterHtml` is handed to the LAST section only. It is set when that
 * section owns the page's scrollport (a full-page HTML/CSS iframe), so the
 * footer has to be rendered inside it rather than after it — see
 * lastSectionOwnsScroll() in ./sectionUtils.
 */

import SectionRegistry from './SectionRegistry';
import SectionWrapper from './SectionWrapper';
import { visibleSections } from './sectionUtils';

export default function DynamicPageRenderer({ sections = [], theme, appBranding, pageVisibility, embeddedFooterHtml = '' }) {
  const visible = visibleSections(sections);

  return (
    <>
      {visible.map((section, idx) => {
        const Component = SectionRegistry[section.section_type];
        if (!Component) return null;
        const isLast = idx === visible.length - 1;
        return (
          <SectionWrapper key={section.id || section._clientId} section={section} theme={theme}>
            <Component
              config={section.section_config}
              dataBinding={section.data_binding}
              theme={theme}
              appBranding={appBranding}
              pageVisibility={pageVisibility}
              embeddedFooterHtml={isLast ? embeddedFooterHtml : ''}
            />
          </SectionWrapper>
        );
      })}
    </>
  );
}
